<ng-container *ngIf="!loaded">
  <div class="modal-header text-center p-3">
    <i aria-label="Close" (click)="handleClick({ close: true })" class="close pull-right align-middle fas fa-times"> </i>
    <h4 class="modal-title w-100">{{ 'MODAL.QUOTATION_TRANSPORTER_RESPONSE.TITLE' | translate }}</h4>
  </div>
  <div class="modal-body">
    <jhi-transport-card [transport]="quotation"></jhi-transport-card>
    <div *ngIf="lastEstimate && lastEstimate.errorMessages && lastEstimate.errorMessages.length > 0" class="col-12 alert alert-danger" role="alert">
      <span class="m-2">{{ 'ERROR.SOME_ELEMENTS_ARE_INVALID' | translate }}</span>
      <ul>
        <li *ngFor="let message of lastEstimate.errorMessages">{{ message }}</li>
      </ul>
    </div>
    <h4 class="my-3">{{ 'QUOTATION.NEW.TITLE' | translate }}</h4>
    <p class="alert alert-info">{{ 'QUOTATION.NEW.INFO' | translate }}</p>
    <div class="row justify-content-center">
      <form class="col-12 col-sm-8" name="form" role="form" [formGroup]="quotationForm" *ngIf="quotationForm">
        <jhi-bary-date-picker
          [title]="'LABEL.PICKUP_DATE' | translate"
          [label]="'LABEL.PICKUP_DATE' | translate"
          [control]="getControl('pickupDate')"
          [disabled]="false"
          [isDisableWeekends]="false"
          [isPickup]="true"
          [options]="pickupOptions"
        ></jhi-bary-date-picker>
        <div class="alert alert-danger small" *ngIf="quotationForm?.errors?.['errorDateForm']">
          {{ 'MODAL.QUOTATION_TRANSPORTER_RESPONSE.WRONG_PICKUP_DATE' | translate }}
        </div>
        <jhi-bary-date-picker
          [title]="'LABEL.DELIVERY_DATE' | translate"
          [label]="'LABEL.DELIVERY_DATE' | translate"
          [control]="getControl('deliveryDate')"
          [disabled]="false"
          [isDisableWeekends]="false"
          [options]="deliveryOptions"
        ></jhi-bary-date-picker>
        <div class="d-flex flex-column flex-xl-row mx-0" *ngIf="quotation.isFTL()">
          <jhi-bary-input-select
            class="flex-grow-1 pr-xl-2"
            [control]="getControl('vehicleCategory')"
            [label]="'LABEL.VEHICLE_CATEGORY' | translate"
            [placeholder]="'TRANSPORT_ESTIMATION_STEP.VEHICLE_CATEGORY.PLACEHOLDER' | translate"
            [options]="categories"
          ></jhi-bary-input-select>
          <jhi-bary-input-select
            class="flex-grow-1"
            [control]="getControl('vehicleType')"
            [label]="'LABEL.VEHICLE_TYPE' | translate"
            [placeholder]="'TRANSPORT_ESTIMATION_STEP.VEHICLE_TYPE.PLACEHOLDER' | translate"
            [options]="types"
          ></jhi-bary-input-select>
        </div>
        <jhi-bary-input-price
          [label]="'LABEL.PRE_TAXES_PRICE_WITH_DETAILS' | translate"
          [control]="getControl('quotationBasePrice')"
          data-id-cypress="prix-quotation"
          id="field_quotationBasePrice"
        ></jhi-bary-input-price>
        <jhi-bary-date-picker
          [title]="'LABEL.QUOTATION_VALIDITY_DATE' | translate"
          [label]="'LABEL.QUOTATION_VALIDITY_DATE' | translate"
          [control]="getControl('quotationValidityDate')"
          data-id-cypress="date-picker-quotation"
          [disabled]="false"
          [isDisableWeekends]="false"
          [isPickup]="true"
          [options]="pickupOptions"
        ></jhi-bary-date-picker>
        <div *ngIf="getControl('quotationValidityDate').invalid && (getControl('quotationValidityDate').dirty || getControl('quotationValidityDate').touched)">
          <small class="form-text text-danger" *ngIf="getControl('quotationValidityDate').errors?.['required']" jhiTranslate="ERROR.REQUIRED_FIELD">
            This field is required.
          </small>
        </div>
        <div *ngIf="getControl('quotationValidityDate').value && getNbDay(getControl('quotationValidityDate').value) < 7">
          <small
            *ngIf="getNbDay(getControl('quotationValidityDate').value) > 0"
            class="form-text text-warning mt--1"
            jhiTranslate="MODAL.QUOTATION_TRANSPORTER_RESPONSE.TOO_SHORT_VALIDITY_DATE"
            [translateValues]="{ nbDay: getNbDay(getControl('quotationValidityDate').value) }"
          >
            Warning, you are set a short validity date
          </small>
          <small
            *ngIf="getNbDay(getControl('quotationValidityDate').value) == 0"
            class="form-text text-warning mt--1"
            jhiTranslate="MODAL.QUOTATION_TRANSPORTER_RESPONSE.VALIDITY_DATE_IS_TODAY"
            [translateValues]="{ nbDay: getNbDay(getControl('quotationValidityDate').value) }"
          >
            Warning, you are set a same day validity date
          </small>
        </div>
      </form>
      <jhi-estimation-price [showButton]="false" class="col-12 col-sm-8 col-lg-4" [lastEstimate]="lastEstimate"></jhi-estimation-price>
    </div>
  </div>
  <div class="modal-footer justify-content-center">
    <jhi-bary-button class="mr-2" color="white" [label]="'BTN.REFUSE_QUOTATION' | translate" (click)="handleClick({ second: true })"></jhi-bary-button>
    <jhi-bary-button
      color="secondary"
      [disabled]="quotationForm.invalid || !priceIsUpdated"
      [label]="'BTN.VALIDATE_QUOTATION' | translate"
      data-id-cypress="valider-quotation"
      (click)="submit()"
    ></jhi-bary-button>
  </div>
</ng-container>
